module.exports = __webpack_public_path__ + "img/kangshuai2.3ddfddc6.png";